





























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Address from "../../../store/entities/address";
import _ from "lodash";

Vue.use(require("vue-moment"));

@Component
export default class ChangeStamp extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  spinShow: boolean = false;
  collectionCode: any = {};
  mainSerialNoOld = "";
  mainSerialNoNew = "";

  changeStamp() {
    (this.$refs.changeForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$Modal.confirm({
          title: this.L("Tips"),
          content: this.L("Confirm.ChangeStamp"),
          okText: this.L("Yes"),
          cancelText: this.L("No"),
          onOk: () => {
            this.spinShow = true;
            this.$store
              .dispatch({
                type: "collectionCodeProduct/changeStamp",
                data: {
                  mainSerialNoOld: this.collectionCode.mainSerialNo,
                  mainSerialNoNew: this.mainSerialNoNew,
                },
              })
              .then(() => {
                this.reset();
                Util.showSuccessMsg(this, "Success.ChangeStamp");
              })
              .finally(() => {
                this.spinShow = false;
              });
          },
        });
      }
    });
  }
  reset() {
    this.spinShow = false;
    this.collectionCode = {};
    this.mainSerialNoOld = "";
    this.mainSerialNoNew = "";
  }
  async search() {
    if (_.isNil(this.mainSerialNoOld) || _.isEmpty(this.mainSerialNoOld))
      return;
    this.spinShow = true;
    this.$store
      .dispatch({
        type: `collectionCodeProduct/changeStampCollectionCodetInfo`,
        data: { code: this.mainSerialNoOld },
      })
      .then((result) => {
        this.collectionCode = result;
      })
      .finally(() => {
        this.spinShow = false;
      });
  }
  async created() {}
}
